var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['sticky-block-wrap']},[_c('jtn-ui-base-block-will-deprecate',{attrs:{"header":_vm.title,"url":_vm.hash,"has-icon":false},on:{"headerClicked":function($event){return _vm.setHash(_vm.hash)}}},[_c('div',{ref:"list",class:[
        _vm.$style['scroll-block'],
        _vm.$style[_vm.hasScroll ? 'has-scroll' : ''],
        _vm.$style[_vm.isTop ? 'top' : ''],
        _vm.$style[_vm.isBottom ? 'bottom' : '']
      ],style:({ maxHeight: _vm.height > 0 ? (_vm.height + "px") : 'auto' }),attrs:{"slot":"content"},slot:"content"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }